<mat-form-field appearance="outline" class="search-box">   
    <input matInput placeholder="dd" class="search-input">
    <i class="icon-search search-icon"></i>   
</mat-form-field>